import React, { useState } from "react";

export default function App() {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Welcome to the Norlake Masterbilt Technical Assistant! How can I help you?" }
  ]);
  const [input, setInput] = useState("");

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages([...messages, userMessage]);

    try {
      // Send user input to OpenAI
      const response = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer YOUR_OPENAI_API_KEY`  // Replace with actual OpenAI API key
        },
        body: JSON.stringify({
          model: "gpt-4",
          messages: [{ role: "user", content: input }]
        })
      });

      const data = await response.json();
      if (data.choices && data.choices.length > 0) {
        const botMessage = { sender: "bot", text: data.choices[0].message.content };
        setMessages([...messages, userMessage, botMessage]);

        // 🎤 Send the bot response to HeyGen for speech
        playSpeech(botMessage.text);
      } else {
        console.error("No response received from OpenAI.");
      }

    } catch (error) {
      console.error("Error:", error);
    }

    setInput("");
  };

  // 🎤 Function to convert text to speech with HeyGen
  const playSpeech = async (text) => {
    try {
      const response = await fetch("https://api.heygen.com/v1/speech", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer YOUR_HEYGEN_API_KEY`  // Replace with actual HeyGen API key
        },
        body: JSON.stringify({
          text: text,
          voice: "Abrey",  // HeyGen avatar name
          format: "mp3"
        })
      });

      const data = await response.json();
      if (data.audioUrl) {
        new Audio(data.audioUrl).play(); // 🎤 Play the audio response
      } else {
        console.error("No audio response from HeyGen.");
      }
    } catch (error) {
      console.error("Error with HeyGen:", error);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>
            {msg.text}
          </div>
        ))}
      </div>
      <div className="input-container">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your question..."
          className="chat-input"
        />
        <button onClick={sendMessage} className="send-button">Send</button>
      </div>
    </div>
  );
}
